/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface FxIdWebFeaturesAuthOauthUserInfoResponse
 */
export interface FxIdWebFeaturesAuthOauthUserInfoResponse {
    /**
     * 
     * @type {string}
     * @memberof FxIdWebFeaturesAuthOauthUserInfoResponse
     */
    Sub: string;
    /**
     * 
     * @type {string}
     * @memberof FxIdWebFeaturesAuthOauthUserInfoResponse
     */
    Id: string;
    /**
     * 
     * @type {string}
     * @memberof FxIdWebFeaturesAuthOauthUserInfoResponse
     */
    Email: string;
}

/**
 * Check if a given object implements the FxIdWebFeaturesAuthOauthUserInfoResponse interface.
 */
export function instanceOfFxIdWebFeaturesAuthOauthUserInfoResponse(value: object): value is FxIdWebFeaturesAuthOauthUserInfoResponse {
    if (!('Sub' in value) || value['Sub'] === undefined) return false;
    if (!('Id' in value) || value['Id'] === undefined) return false;
    if (!('Email' in value) || value['Email'] === undefined) return false;
    return true;
}

export function FxIdWebFeaturesAuthOauthUserInfoResponseFromJSON(json: any): FxIdWebFeaturesAuthOauthUserInfoResponse {
    return FxIdWebFeaturesAuthOauthUserInfoResponseFromJSONTyped(json, false);
}

export function FxIdWebFeaturesAuthOauthUserInfoResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): FxIdWebFeaturesAuthOauthUserInfoResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'Sub': json['sub'],
        'Id': json['id'],
        'Email': json['email'],
    };
}

export function FxIdWebFeaturesAuthOauthUserInfoResponseToJSON(json: any): FxIdWebFeaturesAuthOauthUserInfoResponse {
    return FxIdWebFeaturesAuthOauthUserInfoResponseToJSONTyped(json, false);
}

export function FxIdWebFeaturesAuthOauthUserInfoResponseToJSONTyped(value?: FxIdWebFeaturesAuthOauthUserInfoResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'sub': value['Sub'],
        'id': value['Id'],
        'email': value['Email'],
    };
}

